import makeApplicationRoutes from 'routes';
import mainConfigs from 'configs';

import configs from './configs';

const prefix = mainConfigs.routePrefix;
const routes = makeApplicationRoutes(configs, prefix);

export default routes;
